<template>
	<div>
	<div>
	
	  <div id="index">
		  	<div>
		  		<div  class="clearfix">
				  	<h1 class="logo"><router-link to="/"><img src="../../../static/images/s_logo.png" alt="LOGO" width="80"/></router-link></h1>
				    <mt-search v-model="value" placeholder="搜索" v-lfcous></mt-search>
                </div>
					  <swiper :options="swiperOption" ref="mySwiper" class="swiper-box" v-show="module0==1"> 
							    <swiper-slide v-for="(item,index) in swipeList" :key="item.id">
							    	<a :href="item.sLink" target="_blank" v-if="item.sLink!=''"><img :src="urlPrefixImg+'/'+item.sImg" :alt="item.sName"/></a>
							      <a href="javascript:void(0)" v-else=""><img :src="urlPrefixImg+'/'+item.sImg" :alt="item.sName"/></a>
							    </swiper-slide>
							    <div class="swiper-pagination" slot="pagination"></div>
					  </swiper>
					
				<div class="bgcontent" v-show="module1==1">
				<section class="content">
					<dl class="list-menu" v-for="(item,index) in menuList" :key="item.id" :class="{mr0: (index+1) % 3==0}" @click="jumpMenu(item.id,item.tid)">
						<dt>
							<img src="../../../static/images/tel_ico.png" v-if="item.id==14" :alt="item.forName"/>
							<img src="../../../static/images/flow_ico.png" v-else-if="item.id==15" :alt="item.forName"/>
							<img src="../../../static/images/q_ico.png" v-else-if="item.id==16" :alt="item.forName"/>
							<img src="../../../static/images/tv_ico.png" v-else-if="item.id==17" :alt="item.forName"/>
							<img src="../../../static/images/gift_ico.png" v-else-if="item.id==18" :alt="item.forName"/>
							<img src="../../../static/images/all_ico.png" v-else="item.id==19" :alt="item.forName"/>
						</dt>      
						<dd>{{item.forName}}</dd>
					</dl>
				</section>
				</div>
				<p class="colorBox"></p>
				<div v-show="module2==1">
					<p class="text-center font-size10 line-height40 bgfff color666"><span class="colord6d6d6 mr10">——</span>特 惠 专 区<span class="colord6d6d6 ml10">——</span></p>
					<section class="bgfff">
						<div class="special_content" v-for="item in specialList" :key="item.id">
							<dl class="specialList">
							  <dt><img :src="urlPrefixImg+'/'+item.pics.file" v-if="item.pics!=null"/></dt>
							  <dd>
							  	<p class="font-size10 line-height20 color333 reconame">{{item.recoName}}</p>
							  	<p class="mt12">
							  	  <span class="float-left display-inline mt15"><label class="colorff5513 font-size9">￥{{item.price}}</label><label class="color999 font-size8 ml10"><del>￥{{item.marPrice}}</del></label></span>
							  	  <span class="float-right display-inline"><mt-button type="primary" size="small" @click="specialBuy(item.tid,item.id,item.url,item.proType.type)">立即抢购</mt-button></span>
							  	</p>
							  </dd>
							</dl>
						</div>
					</section>
				</div>
				<p class="colorBox"></p>
				<div v-show="module3==1">
				 <p class="text-center font-size10 line-height40 bgfff color666"><span class="colord6d6d6 mr10">——</span>热 门 商 品<span class="colord6d6d6 ml10">——</span></p>
				 <section class="bgfff">
				 	<div v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10">
			 		   <hotList :hotList="hotList"></hotList>
			 		  <p v-show="loadingTextBtn==false" class="text-center font-size7 line-height28 bgf3f3f3 colorccc"><span class="colord6d6d6 mr10">——————</span>我是有底线的<span class="colord6d6d6 ml10">——————</span></p>
			 		 <div class="loading-text" v-show="loadingTextBtn==true">
			 		 	   <span class="text-center inline-block mt5">
			 		 	   	  <label v-text="loadingText" class="float-left font-size7"></label>
			 		 	   	  <mt-spinner class="float-left ml5" v-show="loadingComplete==false" type="snake" :size="10"></mt-spinner>
			 		 	   </span>
			 		 </div>
			 		</div>
				 </section>	 
				</div>
			</div>	
	  </div>
  </div>
  <BottomMenu></BottomMenu>
  </div>
</template>

<script>
	import BottomMenu from '@/components/BottomMenu'
	import hotList from '@/components/hotList'
	import { swiper, swiperSlide } from 'vue-awesome-swiper'
	import { Indicator } from 'mint-ui'
	export default{
		components:{
			BottomMenu,
			swiper,  
      swiperSlide,
      hotList
		},
		data() { 
			return{
				swiperOption: {
		          autoplay: 4000,
		          setWrapperSize :true,
		          loop: true,
		          pagination : '.swiper-pagination',
		          paginationClickable :true,
		          mousewheelControl : true,
		          autoplayDisableOnInteraction: false,
		          observeParents:true,
		    },
				swipeList:[],
				menuList:[],
				moduleShow:[],
				specialList:[],//特惠商品
				hotList:[],//热门商品
			  value:"",
			  module0:"",
			  module1:"",
			  module2:"",
			  module3:"",
			  urlPrefixImg:this.URL_PREFIX_IMG,
			  page:1,
			  totalPages:"",
			  loadingTextBtn:"",
        loadingText:"加载中",
        loadingComplete:false,
        loading:false
			}
		},
		created:function(){
			this.showSwipe();
			this.showModule();
			this.showMenu();
			this.showSpecialList();
			this.showHotList();
	  },
	  mounted(){
	  	let myscrollNav = new IScroll('#index', {
	      probeType: 3,mouseWheel: true, click: true, tap: true
	    })
	    myscrollNav.on('scrollStart', () => {
	      myscrollNav.refresh();
	    });
	  },
	  directives:{
	    	lfcous(el){
	    		let oInput = el.querySelector('input');
			    oInput.onfocus = function() {
			       location.href="/#/Search";
			    };
	    	}
	  },
	  //热门商品排序
//		computed:{
//		   hotList:function(){
//		   	let arr=this.hotList1;
//		   	function fn(a,b){
//					return b.cSort - a.cSort;
//				}
//				arr.sort(fn); 	
//		   	 return arr; 
//		   }
//		},
	  methods: {
	  	//首页轮播
	    showSwipe(){
	    	this.$http.post(this.URL_PREFIX+"/slide/findSlideApi.net")
	  	  .then((res) =>{
//	  	  	console.log(res);
	  	    this.swipeList=res.data.rows;
//	  	    console.log(res.data.rows);
	  	  });
	    },
	    
	    //首页菜单
	    showMenu(){
	    	this.$http.post(this.URL_PREFIX+"/foregmod/findForegmodMenuApi.net")
	  	  .then((res) =>{
	  	    this.menuList=res.data.rows;
	  	    //console.log(res.data.rows);
	  	  });
	    },
	    showModule(){
	    	this.$http.post(this.URL_PREFIX+"/foregmod/findTopModularApi.net")
	  	  .then((res) =>{
	  	   this.moduleShow=res.data.rows;
	  	   this.module0=res.data.rows[0].selected;
	  	   this.module1=res.data.rows[1].selected;
	  	   this.module2=res.data.rows[2].selected;
	  	   this.module3=res.data.rows[3].selected;
	  	   
	  	  });
	    },
	    //请求特惠专区商品列表数据
	    showSpecialList(){
	    	this.$http.post(this.URL_PREFIX+"/product/findPreferentialProduct.net")
	  	  .then((res) =>{
	  	   this.specialList=res.data.rows;
//	  	   console.log('特惠商品列表排序前');
//	  	   console.log(res.data.rows);
	  	  });
	    },
	    //请求热门商品列表数据
	    showHotList(){
	    	this.$http.post(this.URL_PREFIX+"/category/findHotCategoryType.net",{page:this.page,rows:10})
	  	  .then((res) =>{
//	  	  	console.log('热门商品');
//	  	  	console.log(res);
	  	   this.hotList=res.data.rows;
//	  	   console.log(res.data.rows);
	  	   this.totalPages=res.data.pageSize;
	  	  });
	    },
	    //热门商品加载更多
	    loadMore(){
	      this.loading = true;
	      setTimeout(() => {
	      	this.loadingTextBtn=true;
          this.page++;
          if(this.page<=this.totalPages){
          this.$http.post(this.URL_PREFIX+"/category/findHotCategoryType.net",{page:this.page,rows:10})
	  	    .then((res) =>{
	  	  	     this.hotList=this.hotList.concat(res.data.rows);
//	  	  	     console.log('加载更多');
//	  	  	     console.log(this.hotList);
	  	    });
          }else{
            this.loadingText="";
            this.loadingComplete=true;
            this.loadingTextBtn=false;
          }
            this.loading = false;
            
        }, 2500);
	    },
	    jumpMenu:function(id,tids){
	    	//14 充话费    15充流量    16充Q币  17视频会员   18礼品卡  19全部 
	    	if(id==14){
	    		this.$router.push({path: "/BillDirect"});
	    	}else if(id==15){
	    		this.$router.push({path: "/FlowDirect"});
	    	}else if(id==16){
	    		this.$router.push({path: "/QDirect"});
	    	}else if(id==17 || id==18){
	    		this.toCatorage(tids);
	    		//this.$router.push({path: "/Category",query: {gtids:tids}});
	    	}
//	    	else if(id==18){
//	    		this.$router.push({path: "/Category",query: {gtids:tids}});
//	    	}
	    	else{
	    		this.$router.push({path: "/Category"});
	    	}
	    	localStorage.setItem("tid",tids);
	    	localStorage.removeItem("faceId");
	    	localStorage.removeItem("ttype");
	    },
	    //跳到商品分类页面
	    toCatorage(tida){
	    	Indicator.open();
	    	this.$http.post(this.URL_PREFIX+"/category/findCategoryTypeById.net",{tid:tida})
	  	    .then((res) =>{
	  	    	Indicator.close();
	  	    	 //console.log(res);
	  	  	     if(res.status==200){
	  	  	     	 let cid=res.data.obj.cid;
	  	  	     	 //console.log(cid);	  	  	     	
	  	  	       this.$router.push({path: "/Category",query: {gtids:cid}});
	  	  	     }
	  	    });
	    },
	    //特惠商品点击立即购买
	    specialBuy(tids,faceId,urls,ttype){
	       	localStorage.setItem("tid",tids);
	       	localStorage.setItem("ttype",ttype);
	       	localStorage.setItem("faceId",faceId);
	    	  if(urls!=""){
	    	  	location.href=urls;
	    	  }else if(ttype==0){
	    	  	 this.$router.push({path: "/Reallygood"});//实物
//             this.$router.push({path: "/Order/goodsorderInfo"});//实物订单
	    	  }else{
//	    	  this.$router.push({path: "/Reallygood"});//实物
//            this.$router.push({path: "/Recharge"});//直充
               this.$router.push({path: "/Cami"});//卡密
//              this.$router.push({path: "/UserCenter/selectAddress"});//选择收货地址
//            this.$router.push({path: "/UserCenter/manageAddress"});//地址管理addAddress
//            this.$router.push({path: "/UserCenter/addAddress"});//添加地址
//            this.$router.push({path: "/UserCenter/addAddresstwo"});//添加地址css按钮
//            this.$router.push({path: "/underwriting"});//选择收货地址
//            this.$router.push({path: "/Order/goodsorderInfo"});//实物订单
//            this.$router.push({path: "/UserCenter/lookLogistics"});//查看物流
	    	  }
	    }
	  }
	}
</script>   

<style scoped="scoped">
@import "../../../static/css/swiper.min.css";
#index{width: 100%;position: absolute;top: 0px;left: 0;bottom: 56px;overflow:hidden;}
.logo{float: left;background: #ff8920;height: 52px;line-height: 60px;padding-left: 15px;}
.logo a img{border: none; margin-top: 6px;}
.content{width: 90%;overflow: hidden;margin: 10px auto auto auto;}
.special_content{width: 100%;border-top:1px solid #eee;padding: 12px 0 4px 0;display: inline-block;}
.list-menu{float: left;margin:0 5% 6% 0;width: 30%;}
.list-menu.mr0{margin-right: 0;}
.list-menu dt,.specialList dt{width: 50px;margin: 0 auto;overflow: hidden;}
.list-menu dt img,.specialList dt img{width: 100%;}
.list-menu dd{text-align: center;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;margin-top: 2px;font-size: 0.8rem;margin: 0 auto;color: #333;}
.mint-button--primary{background: #ff8920;}
.specialList{width: 90%;margin: 0 auto;}
.specialList dt{float: left;width: 66px;}
.specialList dd{float: left; margin-left: 12px;width: 72%;}
.specialList dd p.reconame{width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;}
.loading-text{text-align: center;color: #666;font-size: 0.8rem;}
.is-fixed1{    right: 0;
    top: 0;
    left: 0;
    position: fixed;
    z-index: 1;}
</style>


// WEBPACK FOOTER //
// src/views/Home/index.vue